/**
 * Product interplay HF1 (2026-10-25): the ET bar, co-branded shell, return link and sector terms.
 *
 * Off by default. While `VITE_INTERPLAY_SHELL_ENABLED` is anything but the string "true", nothing
 * in this folder renders, the shell endpoint is never called, and the app looks exactly as before.
 */
export function interplayShellEnabled(): boolean {
  return import.meta.env.VITE_INTERPLAY_SHELL_ENABLED === 'true';
}

/** This product's own code and words. AnooreHR may name itself; it never names another product. */
export const SELF = {
  name: 'AnooreHR',
  // The capability label ("HR & Payroll") is i18n: `interplay.capability_label` (KR3 Q81).
  markSrc: '/interplay/anoorehr-mark.svg',
  /** AnooreHR's own brand, used when the customer has not set one (no-brand variant). */
  defaultAccent: '#1A3C8F',
} as const;

/** Where "Your products and billing" goes inside this product. */
export const BILLING_PATH = '/settings#billing-plans';
